import { render, staticRenderFns } from "./Sorter.vue?vue&type=template&id=21ddc72e"
import script from "./Sorter.vue?vue&type=script&lang=js"
export * from "./Sorter.vue?vue&type=script&lang=js"
import style0 from "./Sorter.vue?vue&type=style&index=0&id=21ddc72e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports